import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Input } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { isEmpty } from "lodash";
import { Filter } from "ceicons";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";
import { toast } from "react-toastify";
import PillWithButton from "../../PillWithButton";
import _ from "lodash";

import "./filtersModal.scss";

export default function FiltersModal(props) {
  const { trigger, edit = false, label, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [pills, setPills] = useState([]);
  const labelInput = useRef(null);
  const t = useTranslation();

  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  function handleChangeLabel(evt) {
    const { value } = evt.target;

    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  useEffect(() => {
    if (_.endsWith(formData.labels, ",")) {
      const getLabelString = _.split(formData.labels, ",");
      let newPills = [...pills];

      let finalFilter = _.trim(getLabelString[0]);

      if (finalFilter !== "") {
        let isRepeat = false;
        _.map(newPills, (pill) => {
          if (pill === finalFilter) {
            isRepeat = true;
          }
        });

        if (!isRepeat) {
          newPills.push(finalFilter);

          setPills(newPills);
        }
      }

      setFormData({
        ...formData,
        labels: "",
      });
    }
  }, [formData, pills]);

  function editFilter() {
    return new Promise((resolve, reject) => {
      const variables = {
        id: formData.id,
        name: formData.name,
        labels: pills,
      };

      commitMutation(environment, {
        mutation: FiltersModalUpdateLabelGroupMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  function createFilter() {
    return new Promise((resolve, reject) => {
      const variables = {
        name: formData?.name,
        labels: pills,
      };

      commitMutation(environment, {
        mutation: FiltersModalCreateLabelGroupMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? createFilter : editFilter;
      const msg = !edit
        ? t("message.created_filter")
        : t("message.edited_filter");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.name) {
      errors = { ...errors, slugName: t("form.errorRequired") };
    }

    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  const deleteTag = (id) => {
    let newArray = [];
    _.map(pills, (item) => {
      if (item !== id) {
        newArray.push(item);
      }
    });

    setPills(newArray);
  };

  return (
    <BasicModal
      size="mini"
      className="single-button"
      title={
        <div className="modalTitle">
          <Filter />
          {edit ? t("modalTitle.editFilter") : t("modalTitle.createFilter")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          const getPills = _.map(label?.label, (item) => {
            return item.node.name;
          });

          edit
            ? setFormData({ id: label.id, name: label.name })
            : setFormData({});
          edit ? setPills(getPills) : setPills([]);
        },
      })}
      actions={
        <Button
          type="submit"
          primary
          onClick={() => {
            onSubmit();
          }}
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form className="filter-modal">
        <Form.Input
          name="name"
          error={formErrors && formErrors["name"]}
          value={formData.name || ""}
          label={<p className="title">{t("form.name")}</p>}
          placeholder={t("form.name_filter")}
          onChange={handleChange}
        />

        <div>
          <p className="title">Etiquetas</p>
          <div
            className="filter-pills"
            onClick={() => labelInput.current.focus()}
          >
            {!!pills.length &&
              _.map(pills, (pill, index) => (
                <PillWithButton
                  key={`pill-${index}`}
                  pill={pill}
                  onRemove={() => deleteTag(pill)}
                />
              ))}

            <Input
              ref={(node) => {
                labelInput.current = node;
              }}
              className="filter-pills_input"
              name="labels"
              error={formErrors && formErrors["labels"]}
              value={formData.labels || ""}
              placeholder={!!pills.length ? "" : t("form.labels")}
              onChange={handleChangeLabel}
            />
          </div>
        </div>
      </Form>
      <p className="info-labels">{t("form.info_labels")}</p>
    </BasicModal>
  );
}

const FiltersModalCreateLabelGroupMutation = graphql`
  mutation FiltersModalCreateLabelGroupMutation(
    $name: String!
    $labels: [String]
  ) {
    labelGroupCreate(input: { name: $name, labels: $labels }) {
      labelGroup {
        name
        labels {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

const FiltersModalUpdateLabelGroupMutation = graphql`
  mutation FiltersModalUpdateLabelGroupMutation(
    $id: ID!
    $name: String!
    $labels: [String]
  ) {
    labelGroupUpdate(input: { id: $id, name: $name, labels: $labels }) {
      labelGroup {
        id
        name
        labels {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;
